import styled, { css } from 'styled-components';
import Btn010 from 'dc/Btn010';
import NotiDot from 'dc/NotiDot';
import ChaDSc1 from 'dc/ChaDSc1';
import TipComponent from 'dc/Tip';

export const Wrapper = styled.div`
  width: 342px;
  height: 40px;
  border-left: 1px solid #cfd8dc;
  display: flex;
  justify-content: space-between;
  padding-left: 28px;
`;

export const DailyScoreInfo = styled(ChaDSc1)`
  padding-left: ${props => (props.inactive ? '75px' : 'inherit')};
`;

export const ArrowButton = styled(Btn010)`
  background-color: transparent;
  &:focus {
    background-color: rgba(38, 50, 56, 0.04);
    outline: none;
  }
  &:hover {
    background-color: rgba(38, 50, 56, 0.04);
  }
  & > i {
    color: #607d8b;
  }
  ${props =>
    props.disabled
      ? css`
          background-color: transparent;
          &:hover {
            background-color: transparent;
          }
          & > i {
            color: rgba(38, 50, 56, 0.24);
          }
        `
      : null};
`;

export const Dot = styled(NotiDot)`
  div {
    top: -4px;
    left: -31px;
  }
`;

export const Tip = TipComponent;
